module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-edit/event-edit.component.scss
// module id = ./src/app/routes/event/event-edit/event-edit.component.scss
// module chunks = 9